import { heroStats } from "@/mocks/media";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950 text-background-50">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20composition%20of%20a%20dark%20press%20studio%20stage%20with%20a%20single%20dramatic%20crimson%20spotlight%20beaming%20through%20haze%20toward%20a%20vintage%20microphone%20and%20newspaper%20sheets%20scattered%20on%20a%20table%2C%20warm%20amber%20rim%20light%20against%20deep%20charcoal%2C%20chiaroscuro%2C%20film%20grain%2C%20premium%20editorial%20magazine%20aesthetic&width=1800&height=1100&seq=sl-hero-main&orientation=landscape"
          alt="红色聚光灯下的话筒与报纸暗调编辑部场景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/70 to-foreground-950/35" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-transparent to-foreground-950/40" />
      </div>

      <div className="relative mx-auto flex min-h-[640px] max-w-[1280px] flex-col justify-center px-4 py-28 md:px-6 md:py-36">
        <div className="flex w-full items-center gap-3">
          <span className="h-px w-10 bg-primary-500" />
          <span className="text-xs font-medium uppercase tracking-[0.3em] text-accent-400">
            娱乐舆论与危机公关观察
          </span>
        </div>

        <h1 className="mt-6 max-w-4xl font-heading text-3xl font-bold leading-[1.18] tracking-tight text-white md:text-5xl">
          当\u201c明星黑料\u201d刷屏，
          <br className="hidden sm:block" />
          真正值得看清的是屏幕后的
          <span className="text-primary-400">公关攻防</span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-8 text-foreground-200 md:text-lg">
          辟谣如何反转、律师函与删帖记录背后藏着怎样的角力、水军与控评又如何改变\u201c公共情绪\u201d
          ——我们以编辑部视角拆解娱乐危机公关的每一层套路，帮你在真相与话术之间找到坐标。
        </p>

        <div className="mt-9 flex w-full flex-col gap-3 sm:flex-row">
          <a
            href="#focus"
            className="inline-flex items-center justify-center whitespace-nowrap gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            浏览本期焦点档案
            <i className="ri-arrow-right-line text-base" />
          </a>
          <a
            href="#timeline"
            className="inline-flex items-center justify-center whitespace-nowrap gap-2 rounded-md border border-foreground-300/40 px-6 py-3 text-sm font-medium text-foreground-100 transition-colors hover:border-accent-400 hover:text-accent-300"
          >
            看攻防时间线
          </a>
        </div>
      </div>

      <div className="relative border-t border-foreground-700/40">
        <div className="mx-auto grid max-w-[1280px] grid-cols-2 gap-px bg-foreground-700/40 px-4 sm:grid-cols-4 md:px-6">
          {heroStats.map((s) => (
            <div key={s.label} className="flex flex-col gap-1 bg-foreground-950/80 px-4 py-5 md:px-6">
              <span className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{s.value}</span>
              <span className="text-xs text-foreground-400 md:text-sm">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}